interface NoibuAttribute {
    name: string;
    value: string;
}

function getNoibuJS() {
    return (window as any).NOIBUJS;
}

export function addCustomAttribute(name: string, value: string) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const noibuJs = getNoibuJS();

    if (!noibuJs) {
        return;
    }

    const noibuAttribute: NoibuAttribute = {
        name,
        value
    };

    noibuJs.addCustomAttribute(noibuAttribute.name, noibuAttribute.value);
}